import { isGlobalworth, paths } from 'config'
import { ResourceProfiles, DrawerResourceProfiles } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.resourceProfiles,
    admin: true,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? ResourceProfiles : DrawerResourceProfiles,
      label: 'nav.resourceProfiles',
    },
    component: Loadable({
      component: () => import('./pages/ResourceProfiles'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.addResourceProfile,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/AddResourceProfile'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.resourceProfile,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/ResourceProfile'),
    }),
    layoutSettings: {},
  },
]

export default routes
